import { render } from "./guide-list.vue?vue&type=template&id=44486f66&scoped=true"
import script from "./guide-list.vue?vue&type=script&lang=js"
export * from "./guide-list.vue?vue&type=script&lang=js"

import "./guide-list.vue?vue&type=style&index=0&id=44486f66&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\fuvview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44486f66"]])

export default __exports__